export default __webpack_public_path__ + "static/media/Paradiseao.62330d7a.PNG";